import { Link } from 'react-router-dom';
import type { CatalogueProduct } from '../types';
import { Price } from './Price';

export function ProductCard({ product, slug, layout }: { product: CatalogueProduct; slug: string; layout: 'grid' | 'list' | 'cards' }) {
  const img = product.images[0];
  const outOfStock = product.variants.length > 0 && product.variants.every((v) => v.inStock === false);
  const to = `/${slug}/p/${product.slug}`;

  if (layout === 'list') {
    return (
      <Link to={to} className="flex gap-3 rounded-xl bg-white p-3 shadow-sm ring-1 ring-stone-200/70 dark:bg-stone-900 dark:ring-stone-800">
        <Thumb src={img} alt={product.name} className="size-20 shrink-0 rounded-lg" />
        <div className="min-w-0 flex-1">
          <div className="line-clamp-2 font-medium text-stone-900 dark:text-stone-100">{product.name}</div>
          {product.unit && <div className="text-xs text-stone-500">per {product.unit}</div>}
          <div className="mt-1 flex items-center justify-between">
            <Price value={product.priceFrom} from={product.variants.length > 1} />
            {outOfStock && <span className="text-xs text-stone-500">Out of stock</span>}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={to} className={`flex flex-col overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-stone-200/70 dark:bg-stone-900 dark:ring-stone-800 ${outOfStock ? 'opacity-70' : ''}`}>
      <Thumb src={img} alt={product.name} className={layout === 'cards' ? 'aspect-[4/3] w-full' : 'aspect-square w-full'} />
      <div className="flex flex-1 flex-col p-3">
        <div className="line-clamp-2 text-sm font-medium text-stone-900 dark:text-stone-100">{product.name}</div>
        {layout === 'cards' && product.description && <div className="mt-1 line-clamp-2 text-xs text-stone-500">{product.description}</div>}
        <div className="mt-auto flex items-center justify-between pt-2">
          <Price value={product.priceFrom} from={product.variants.length > 1} />
          {outOfStock ? <span className="text-xs text-stone-500">Out of stock</span> : product.unit && <span className="text-xs text-stone-500">/ {product.unit}</span>}
        </div>
      </div>
    </Link>
  );
}

export function Thumb({ src, alt, className }: { src: string | undefined; alt: string; className: string }) {
  if (!src) {
    return (
      <div className={`grid place-items-center bg-stone-100 text-stone-300 dark:bg-stone-800 dark:text-stone-600 ${className}`} aria-hidden>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="3" /><circle cx="9" cy="9" r="2" /><path d="M21 15l-5-5L5 21" /></svg>
      </div>
    );
  }
  return <img src={src} alt={alt} loading="lazy" decoding="async" className={`bg-stone-100 object-cover dark:bg-stone-800 ${className}`} />;
}
